var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 11.05C3.5575 11.05 2.95675 11.6575 2.95675 12.4C2.95675 13.1425 3.5575 13.75 4.3 13.75C5.0425 13.75 5.65 13.1425 5.65 12.4C5.65 11.6575 5.0425 11.05 4.3 11.05ZM0.25 0.25V1.6H1.6L4.03 6.72325L3.11875 8.377C3.01075 8.566 2.95 8.78875 2.95 9.025C2.95 9.7675 3.5575 10.375 4.3 10.375H12.4V9.025H4.5835C4.489 9.025 4.41475 8.95075 4.41475 8.85625L4.435 8.77525L5.0425 7.675H10.0713C10.5775 7.675 11.023 7.39825 11.2525 6.97975L13.669 2.599C13.723 2.5045 13.75 2.38975 13.75 2.275C13.75 1.90375 13.4463 1.6 13.075 1.6H3.09175L2.45725 0.25H0.25ZM11.05 11.05C10.3075 11.05 9.70675 11.6575 9.70675 12.4C9.70675 13.1425 10.3075 13.75 11.05 13.75C11.7925 13.75 12.4 13.1425 12.4 12.4C12.4 11.6575 11.7925 11.05 11.05 11.05Z",
    fill: "#002979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleIcon);
export default __webpack_public_path__ + "static/media/sale-icon.f8c7046032fe36398d5a7a2a393d3af2.svg";
export { ForwardRef as ReactComponent };